export default {
    joinTitle: "Come, work with us which is full of fun",
    joinContent1: "Clean and spacious office area, so that you can work easily and efficiently, leisure and comfortable rest area, let your life to be full of fun",
    joinContent2: "Perfect social security, housing provident fund, paid annual leave, paid sick leave, work related subsidies, such as meal allowance, performance bonus at the end of the year",
    joinContent3: "Competitive salary guarantee, flexible working hours, 5 days per week, 8 hours per day",
    joinJobsTitle: "View jobs",
    jobsName1: "Data Engineer",
    jobsName2: "Senior Python Engineer",
    jobsName3: "Senior Frontend Engineer",
    jobsName4: "CV Algorithm Engineer",
    jobsName5: "Senior Data Scientist",
    jobsName6: "Product Manager",
    jobsButton:"Job Description",
    jobsDetail1: [{
            h3: "Job Responsibilities",
        },

        {
            p: "1.Develop image data processing pipeline and model evaluation tools to be used for model training, data analysis and visualization."
        },
        {
            p: "2.Work closely with data scientist team to improve the model with data."
        },
        {
            p: "3.Understand business/product requirements and implement data-mining techniques to support product growth."
        },
        {
            p: "4.Manage our image data warehouse and build our data platform."
        },
        {
            h3: "Job Requirements"
        },
        {
            p: "1.Bachelor's Degree in Computer Science/Information Technology/Engineering."
        },
        {
            p: "2.Minimum of 2 years of experience."
        },
        {
            p: "3.Excellent experience with Python."
        },
        {
            p: "4.Experience working with cloud-based distributed system."
        },

        {
            p: "5.Passion in the computer vision field with a good learning attitude."
        },

        {
            p: "6.Team player, meticulous, and strong ownership for work."
        }
    ],
    jobsDetail2: [{
            h3: "Job Responsibilities",
        },
        {
            p: "1. Responsible for the design and development of the crawler framework to support multiple data source types and ensure flexibility and ease of use."
        },
        {
            p: "2. Responsible for the design and development of the agent pool, research and implement blocking and anti-blocking schemes."
        },
        {
            p: "3. Responsible for the development of information crawling logic for specific websites and applications."
        },
        {
            p: "4. Responsible for the stable and efficient operation of the online system and provide timely and effective technical support to the company's internal and external customers."
        },
        {
            h3: "Job Requirements"
        },
        {
            p: "1. Bachelor degree or above, major in computer science or mathematics."
        },
        {
            p: "2. A solid foundation, proficient in Python, more than 5 years of development experience."
        },
        {
            p: "3. Familiar with at least one Python framework such as Tornado, Django or Flask."
        },
        {
            p: "4. Familiar with MySQL/MongoDB/Redis and other commonly used database and multi-threaded programming, familiar with standard code version control tools such as Git/Svn."
        },

        {
            p: "5. Excellent logical thinking ability and driving ability, as well as good communication and coordination skills, English reading and writing skills, superior oral English ability is preferred."
        },
        {
            p: "6.  Strict requirements on code quality, follow the industry's Python code specifications, plus points for code cleanliness, and attach importance to Code Review."
        },
        {
            p: "7. Experience in team management."
        }
    ],
    jobsDetail3: [{
            h3: "Job Responsibilities",
        },
        {
            p: "1. Responsible for developing and maintaining the official website and backstage system."
        },
        {
            p: "2. Responsible for developing and maintaining Hybrid Apps."
        },
        {
            p: "3. Responsible for developing and maintaining web App, realising mobile adaptiveness."
        },
        {
            h3: "Job Requirements"
        },
        {
            p: "1. Passionate in coding, robust capabilities in learning."
        },
        {
            p: "2. A solid foundation, proficient in Python, more than 5 years of development experience."
        },
        {
            p: "3. Familiar with NodeJS."
        },
        {
            p: "4. Familiar with Vue framework."
        },
        {
            h3: "Plus"
        },
        {
            p: "Being familiar with React or other front-end framework is a plus."
        },
    ],

    jobsDetail4: [{
            h3: "Job Responsibilities",
        },
        {
            p: "Responsible for CV algorithm to support risk control business, including liveness detecting, OCR, face recognition."
        },
        {
            h3: "Job Requirements"
        },
        {
            p: "1. Master degree or above, majored in computer science."
        },
        {
            p: "2. Familiar with deep learning and at least one machine learning framework. (Caffe/TensorFlow)."
        },
        {
            p: "3. Familiar with deep neural network both theoretically and practically."
        },
        {
            p: "4. Familiar with Python and C++."
        },
        {
            p: "5. Have good teamwork spirits and the passion for technology."
        },
        {
            h3: "Plus"
        },
        {
            p: "Experience in ACM, Topcoder or Hackathons, or relevant project is a plus."
        },
    ],
    jobsDetail5: [{
            h3: "Job Responsibilities",
        },
        {
            p: "1. Build up credit analysis model with a mass of data."
        },
        {
            p: "2. Conduct feature engineering to mass data, including feature selection and combination."
        },
        {
            p: "3. Construct large-scale machine learning algorithm platforms."
        },
        {
            h3: "Job Requirements"
        },
        {
            p: "1. Have Working experiences in credit risk management."
        },
        {
            p: "2. Have good English skills, fluent in business communication."
        },
        {
            p: "3. Have a good understanding of the risk management process, experiences in hands-on developing risk control model is a plus."
        },
        {
            p: "4. Understand standard risk control modelling methods, and be able to express them clearly and accurately."
        },
        {
            h3: "Plus"
        },
        {
            p: "1. Have published paper as the first author in A conference like ICML, NIPS, SIGIR, SIGKDD."
        },
        {
            p: "2. Participate in the well-known open-source project."
        },
        {
            p: "3. Familiar with Apache spark."
        },
        {
            p: "4. Have passionate about entrepreneurship."
        },
    ],
    jobsDetail6: [{
            h3: "Job Responsibilities",
        },
        {
            p: "1. Design and build up risk management solution product, planning risk management product developing matrix."
        },
        {
            p: "2. Cooperate with the engineering team in developing and testing bigdata and risk solution platform."
        },
        {
            p: "3. Responsible for data access, planning and implementing of customised risk management solution."
        },
        {
            p: "4. Conduct oversea clients demand research, design and developing targeting products."
        },
        {
            h3: "Job Requirements"
        },
        {
            p: "1. 2-year experiences in risk control or risk management product, background in banks or Internet industry is a plus."
        },
        {
            p: "2. Capable of understanding data analysis and fast learning, proactive learning and thinking about the logic in product design."
        },
        {
            p: "3. Capable of independently conducting competitor research, client demand analysis and writing PRD."
        },
        {
            p: "4. Strong responsiveness in communication and coordination, clearly pointing out issues in projects."
        },
        {
            p: "5. Workable English skills, overseas experience is a plus."
        },
        {
            p: "6. Passionate in entrepreneurship, being creative."
        },
    ],
}